import axios from "axios";
import {Storage} from "@/Services/Storage";

export default {
    name: 'orders',
    state: {
        itemsToScan: [],
        scannedItems: [],
        pallets: []
    },
    getters: {
        getItemsToScan: (state) => state.itemsToScan,
        getScannedItems: (state) => state.scannedItems,
        getPallets: (state) => state.pallets,
        getAllPalletItems: (state) => {
            return state.pallets.flatMap(p =>
                p.items.map(i => ({ ...i, palletId: p.palletId }))
            );
        }
    },
    mutations: {
        setItemsToScan: (state, payload) => {
            state.itemsToScan = payload;
        },

        setScannedItems: (state, payload) => {
            state.scannedItems = payload;
        },

        addPallet(state, { palletId, items }) {
            state.pallets.push({ palletId, items });
        },
        clearScannedItems(state) {
            state.scannedItems = [];
        },
        clearPallets(state) {
            state.pallets = [];
        },

        UpdatePallets(state, pallets) {
            state.pallets = pallets;
        },

        removeScannedItems: (state, payload) => {
            const id = payload.id;

            let itemToUpdate = state.itemsToScan.find(item => item.id === id);

            if (!itemToUpdate) {
                return responses.showWarning(`Item not Found !!`);
            }

            if (itemToUpdate.qty > 1) {
                itemToUpdate.qty--;
            } else {
                state.itemsToScan = state.itemsToScan.filter(item => item.id !== id);
            }

            let scannedItem = state.scannedItems.find(item => item.id === id);
            if (scannedItem) {
                scannedItem.notCheckedOutReason = payload.notCheckedOutReason;
            } else {
                state.scannedItems.push({
                    ...payload,
                    notCheckedOutReason: payload.notCheckedOutReason
                });
            }
        },
        addToScannedItems: (state, payload) => {
            let id = payload.id;
            let notScanned = state.itemsToScan.find(notScanned => notScanned.id === id);
            if (!notScanned) {
                return responses.showWarning(`Item not Found !!`);
            }

            if (notScanned.qty > 1) {
                notScanned.qty--;
            } else {
                state.itemsToScan = state.itemsToScan.filter(item => item.id !== id);
            }

            let item = state.scannedItems.find(item => item.id === id);

            if (item) {
                if (item.scannedQty < ((item.scannedQty) + 1)){
                    item.scannedQty = Number(item.scannedQty) + 1;
                }
            } else {
                state.scannedItems.push({
                    id: payload.id,
                    plu: payload.plu,
                    barcode: payload.barcode,
                    barcode2: payload.barcode2,
                    barcode3: payload.barcode3,
                    description: payload.description,
                    unit_of_measure: payload.unit_of_measure,
                    qty: payload.qty,
                    scannedQty: 1,
                    RequiredQty: payload.RequiredQty,
                    PickedQty: payload.PickedQty,
                    pickingID: payload.PickingID,
                    notPickedReason: payload.notPickedReason,
                    notCheckedOutReason: payload.notCheckedOutReason,
                    lotNumber: payload.lotNumber,
                    expiryDate: payload.expiryDate,
                })
            }
        },
    },
    actions: {
        registerPallet({ commit, state }) {
            if (!state.scannedItems.length) return;

            const palletId = `${Date.now()}`;
            const items = state.scannedItems.map(i => ({ ...i }));

            commit("addPallet", { palletId, items });

            console.log(items)

            commit("clearScannedItems");
        },
        getItemsByOrderNumber: async (context, orderNumber) => {
            try {
                let user = await Storage.getCurrentUser();
                if (!user || !user.id) {
                    throw new Error("User is not authenticated");
                }
                user = user.id;
                const response = await axios.get(navTomcatApi + `checkout/open?id=${orderNumber}&User=${user}`);

                if (!Array.isArray(response.data)) {
                    throw new Error("Invalid response format");
                }

                const grouped = {};
                for (const item of response.data) {
                    const key = `${item.barcode}_${item.expiryDate || ''}_${item.lotNumber || ''}`;
                    if (!grouped[key]) grouped[key] = [];

                    grouped[key].push({ ...item });
                }

                const combinedItems = [];

                for (const groupKey in grouped) {
                    const group = grouped[groupKey];
                    if (group.length === 1) {
                        combinedItems.push({
                            ...group[0],
                            requiredQty: group[0].qty,
                        });
                        continue;
                    }

                    const totalQty = group.reduce((sum, i) => sum + i.qty, 0);
                    const isWhole = totalQty % 1 === 0;

                    if (isWhole) {
                        const baseItem = group[0];
                        combinedItems.push({
                            ...baseItem,
                            qty: totalQty,
                            requiredQty: totalQty,
                        });
                    } else {
                        group.forEach(item => {
                            combinedItems.push({
                                ...item,
                                requiredQty: item.qty,
                            });
                        });
                    }
                }

                context.commit("setItemsToScan", combinedItems);
                return combinedItems;
            } catch (error) {
                console.error("Error in getItemsByOrderNumber:", error);
                return [];
            }
        },
        downloadPdf: async (context, orderNumber) => {
            try {
                // const user = await Storage.getCurrentUser();

                const response = await axios.get(`${wareHouseTomcatApi}nav/checkout/download-pdf`, {
                    params: {
                        id: orderNumber,
                    },
                    responseType: 'blob',
                });

                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Order_${orderNumber}.pdf`);
                document.body.appendChild(link);
                link.click();
                link.remove();
            } catch (err) {
                errorHandler.tomcatError(err);
            }
        },
        finalizeOrder: async (context, orderNumber) => {
            try {
                let user = await Storage.getCurrentUser();
                if (!user || !user.id) throw new Error("User is not authenticated");

                // Safety: if there are any remaining scanned items not yet registered as a pallet,
                // auto-register them now so they are included in the final payload.
                if (context.state.scannedItems && context.state.scannedItems.length > 0) {
                    context.dispatch('registerPallet');
                }

                const pallets = context.state.pallets.map(pallet => ({
                    palletNumber: pallet.palletId,
                    items: pallet.items.map(item => ({
                        id: item.id,
                        plu: item.plu,
                        barcode: item.barcode,
                        barcode2: item.barcode2,
                        barcode3: item.barcode3,
                        description: item.description,
                        unit_of_measure: item.unit_of_measure,
                        qty: item.qty,
                        scannedQty: item.scannedQty,
                        lineNo: item.lineNo || "",
                        binId: item.binId || "",
                        notPickedReason: item.notPickedReason || "",
                        lotNumber: item.lotNumber || "",
                        expiryDate: item.expiryDate || "",
                        notCheckedOutReason: item.notCheckedOutReason || "",
                        requiredQty: item.requiredQty || item.RequiredQty || 0,
                        pickingID: item.pickingID || orderNumber,
                        pickedQty: item.pickedQty || item.PickedQty || 0
                    }))
                }));

                const payload = {
                    salesOrderId: orderNumber,
                    userId: user.id,
                    pallets
                };

                await axios.post(`${navTomcatApi}checkout/completedpallet`, payload);

                // TODO (Junie): After submitting checkout, generate a URL for each pallet and prepare
                // a payload to be sent to the hardware API. Each entry must be { palletNumber, url } where
                // url = https://lna.abc.co.zm/WarehouseManager/nav/checkout/pallet?palletNumber=${palletNumber}
                // We use global base URLs per guidelines to avoid hardcoding inside modules.
                const palletLinks = pallets.map(p => ({
                    palletNumber: p.palletNumber,
                    url: `https://checkout.abc.co.zm/p${encodeURIComponent(p.palletNumber)}`
                }));
                const hardwarePayload = {
                    salesOrderId: orderNumber,
                    pallets: palletLinks
                };
                // Send pallet links to local hardware API if configured.
                if (window.hardwareApi) {
                    try {
                        await axios.post(`${window.hardwareApi}qr`, hardwarePayload);
                    } catch (e) {
                        console.warn('Hardware API pallet-links post failed', e);
                    }
                }

                // console.log(payload);

                context.commit("setItemsToScan", []);
                context.commit("setScannedItems", []);
                context.commit("clearPallets");
            } catch (err) {
                console.error("Error finalizing order:", err);
                errorHandler.tomcatError(err);
            }
        },
        getAllOrders: async () => {
            let location = await Storage.getCurrentLocationID();
            return axios.get(navTomcatApi + `checkout/getAll?offset=0&limit=1000&location=` + location)
                .then(({data}) => data)
                .catch(err => errorHandler.tomcatError(err))
        },
        updatePalletArrangement: async (context, updatedPallets) => {
            context.commit('UpdatePallets', updatedPallets);
        }
    }
}
